import { CreateAbstractSerializer } from '@ftr/serialization';
import { ModifyAudioLineItemProperties } from './ModifyAudioLineItemProperties';
import { ModifyLineItemProperties } from './ModifyLineItemProperties';
import { ModifyTranscriptLineItemProperties } from './ModifyTranscriptLineItemProperties';
export const modifyLineItemPropertiesSerializer = CreateAbstractSerializer(ModifyLineItemProperties, [
    { discriminator: 'ModifyAudioLineItemProperties', constructor: ModifyAudioLineItemProperties },
    {
        discriminator: 'ModifyTranscriptLineItemProperties',
        constructor: ModifyTranscriptLineItemProperties,
    },
]);
